export const LEARN_BASE_PATH = '/learn'
